module.exports = __webpack_public_path__ + "img/1324758369.4de766b6.jpg";